export default "__VITE_ASSET__CoyNasDN__"